'use client'

import Link from 'next/link'
import * as React from 'react'
import { RemoveScroll } from 'react-remove-scroll'

import EyeLogo from '@/components/svgs/eye-logo.svg'
import IconCross from '@/components/svgs/icon-cross.svg'
import IconDots from '@/components/svgs/icon-dots.svg'
import TheMenuAlbumNav from '@/components/TheMenuAlbumNav'
import { cn } from '@/lib/utils'
import {
  useGlobalStateActions,
  useIsAlbumPage,
  useIsMenuOpen,
  useIsSecondaryMenuOpen,
  useSecondaryButtonAction,
  useSecondaryButtonLabel,
} from '@/state/useGlobalState'

type TheMenuBarProps = {
  title: string
  className?: string
}

export default function TheMenuBar({ title, className }: TheMenuBarProps) {
  const { toggleMenuOpen } = useGlobalStateActions()
  const isMenuOpen = useIsMenuOpen()
  const isSecondaryMenuOpen = useIsSecondaryMenuOpen()
  const secondaryButtonAction = useSecondaryButtonAction()
  const secondaryButtonLabel = useSecondaryButtonLabel()
  const isAlbumPage = useIsAlbumPage()

  return (
    <RemoveScroll enabled={isMenuOpen || isSecondaryMenuOpen}>
      <div
        id='TheMenuBar'
        className={cn(
          'h-[var(--menu-bar-height)] w-full',
          'flex items-center justify-between',
          'vM:w-10 vM:h-full vM:flex-col',
          'border-t-1 border-black',
          'vM:border-r-1 vM:border-t-0',
          'bg-white',
          className,
        )}
      >
        <h1 className='vM:px-0 vM:mt-0 -mt-1 px-3'>
          <span className='visually--hidden absolute'>{title}</span>
          <Link href='/' aria-label='Home'>
            <EyeLogo className='vM:h-auto vM:w-4 h-6 w-auto' />
          </Link>
        </h1>

        {/* ALBUM NAV */}
        {isAlbumPage && <TheMenuAlbumNav />}

        {/* MENU BUTTONS */}
        <div className='vM:block vM:h-auto flex h-full'>
          {secondaryButtonAction && (
            <button
              aria-label={secondaryButtonLabel}
              onClick={secondaryButtonAction}
              className={cn('menu--button')}
            >
              {isSecondaryMenuOpen ? (
                <IconCross
                  className='h-auto w-[40%] transition-transform'
                  style={{
                    transform: 'rotate(45deg)',
                  }}
                />
              ) : (
                <IconDots className='h-auto w-1/2' />
              )}
            </button>
          )}
          <button
            aria-label={isMenuOpen ? 'Close Menu' : 'Open Menu'}
            className={cn('menu--button')}
            onClick={() => toggleMenuOpen()}
          >
            <IconCross
              className='h-auto w-[40%] transition-transform'
              style={{
                transform: isMenuOpen ? 'rotate(45deg)' : 'rotate(0deg)',
              }}
            />
          </button>
        </div>
      </div>
    </RemoveScroll>
  )
}
